document.querySelectorAll('[data-menu-close]').forEach((button) => {
  button.addEventListener('click', () => {
    const menu = document.querySelector('[data-mobile-menu]');
    const toggle = document.querySelector('[data-menu-toggle]');
    if (!menu) return;
    menu.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    toggle?.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => { menu.hidden = true; }, 280);
  });
});

document.querySelectorAll('[data-service-explorer]').forEach((explorer) => {
  const cards = [...explorer.querySelectorAll('[data-service-card]')];
  const search = explorer.querySelector('[data-service-search]');
  const empty = explorer.querySelector('[data-service-empty]');

  const normalize = (value) => value
    .toLocaleLowerCase('nb-NO')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const sliders = [...explorer.querySelectorAll('[data-service-slider]')].map((slider) => {
    const track = slider.querySelector('[data-service-track]');
    const sliderCards = [...slider.querySelectorAll('[data-service-card]')];
    const dots = [...slider.querySelectorAll('[data-slider-dot]')];
    const current = slider.closest('[data-service-group]')?.querySelector('[data-current-slide]');
    const previous = slider.querySelector('[data-slider-prev]');
    const next = slider.querySelector('[data-slider-next]');
    let scrollFrame = null;

    const visibleCards = () => sliderCards.filter((card) => !card.hidden);
    const activeIndex = () => {
      const visible = visibleCards();
      if (!track || visible.length === 0) return 0;
      const trackLeft = track.getBoundingClientRect().left;
      return visible.reduce((best, card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Infinity }).index;
    };
    const update = () => {
      const visible = visibleCards();
      const index = activeIndex();
      if (current) current.textContent = visible.length ? index + 1 : 0;
      dots.forEach((dot, originalIndex) => {
        const card = sliderCards[originalIndex];
        dot.hidden = !card || card.hidden;
        dot.classList.toggle('is-active', Boolean(card && !card.hidden && card === visible[index]));
      });
      if (previous) previous.disabled = visible.length === 0 || index === 0;
      if (next) next.disabled = visible.length === 0 || index >= visible.length - 1;
    };
    const goTo = (card) => {
      if (!track || !card) return;
      const offset = card.getBoundingClientRect().left - track.getBoundingClientRect().left;
      track.scrollBy({ left: offset, behavior: 'smooth' });
    };
    const move = (direction) => {
      const visible = visibleCards();
      const target = Math.max(0, Math.min(visible.length - 1, activeIndex() + direction));
      goTo(visible[target]);
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    track?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
    });
    track?.addEventListener('scroll', () => {
      if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(update);
    }, { passive: true });
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(sliderCards[index])));
    window.addEventListener('resize', update, { passive: true });
    return { track, update };
  });

  const apply = () => {
    const term = normalize(search?.value || '');
    let visible = 0;
    cards.forEach((card) => {
      const searchMatch = !term || normalize(card.dataset.search || '').includes(term);
      card.hidden = !searchMatch;
      if (!card.hidden) visible += 1;
    });
    explorer.querySelectorAll('[data-service-group]').forEach((group) => {
      group.hidden = term !== '' && !group.querySelector('[data-service-card]:not([hidden])');
    });
    if (empty) empty.hidden = visible !== 0;
    sliders.forEach(({ track, update }) => {
      if (track) track.scrollLeft = 0;
      window.requestAnimationFrame(update);
    });
  };

  search?.addEventListener('input', apply);
  apply();
});

const initCarBooking = (scope = document) => {
  scope.querySelectorAll('[data-car-booking]').forEach((booking) => {
    if (booking.dataset.bookingInitialized === 'true') return;
    booking.dataset.bookingInitialized = 'true';

    const modes = [...booking.querySelectorAll('[data-booking-mode]')];
    const choices = [...booking.querySelectorAll('[data-booking-choice]')];
    const calendar = booking.querySelector('[data-booking-calendar]');
    const confirmation = booking.querySelector('[data-booking-confirmation]');
    const dateInput = booking.querySelector('[data-booking-date]');
    const timeInput = booking.querySelector('[data-booking-time]');
    const minimumDays = Math.max(0, Number.parseInt(booking.dataset.minDays || '0', 10) || 0);

    if (dateInput) {
      const minimumDate = new Date();
      minimumDate.setHours(12, 0, 0, 0);
      minimumDate.setDate(minimumDate.getDate() + minimumDays);
      const year = minimumDate.getFullYear();
      const month = String(minimumDate.getMonth() + 1).padStart(2, '0');
      const day = String(minimumDate.getDate()).padStart(2, '0');
      dateInput.min = `${year}-${month}-${day}`;
      if (dateInput.value && dateInput.value < dateInput.min) dateInput.value = '';
    }

    const updateBookingMode = () => {
      const selected = modes.find((mode) => mode.checked);
      const isScheduled = selected?.dataset.bookingMode !== 'flexible';
      calendar?.classList.toggle('is-disabled', !isScheduled);
      calendar?.setAttribute('aria-hidden', String(!isScheduled));
      if (confirmation) confirmation.hidden = !isScheduled;
      [dateInput, timeInput].forEach((field) => {
        if (!field) return;
        field.disabled = !isScheduled;
        field.required = isScheduled;
      });
      choices.forEach((choice) => {
        choice.classList.toggle('is-selected', choice.querySelector('input')?.checked === true);
      });
    };

    modes.forEach((mode) => mode.addEventListener('change', updateBookingMode));
    updateBookingMode();
  });
};

initCarBooking();
document.addEventListener('shopify:section:load', (event) => initCarBooking(event.target));
